import { Box } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import { borderRadius, fontWeight, textAlign } from '@mui/system';
import { bg } from 'styles/theme';
import { thirdly4 } from 'styles/theme';
import { white } from 'styles/theme';


export const UserStyles = muiStyled(Box)(({ theme }) => ({
    height: "100%",
    display: "flex",
    flexDirection: "column",
    rowGap: 20,
    '.disabled': {
        opacity: 0.7,
        pointerEvents: "none"
    },
    '.reset-password': {
        display: "flex",
        columnGap: 5
    },
    '.responsible-title': {
        marginTop: 35,
        fontWeight: "bold"
    },
    '.responsible-sub-title': {
        marginBottom: 20,
        fontSize: 15
    },
    '.affiliation-field': {
        width: 250
    },
    '.user-roles-cards': {
        display: "flex",
        flexDirection: "column",
        rowGap: 20
    },
    '.user-role-data': {
        flexGrow: 1
    },
    '.user-role-card': {
        background: "#F5F9FF",
        borderRadius: 15,
        padding: 20,
        display: "flex",
        columnGap: 20
    },
    '.role-field': {
        width: 250
    },
    '.roles-card': {
        background: "#E6F0FE",
        borderRadius: 8,
        padding: 20
    },
    '.card-actions': {
        width: "100%",
        display: "flex",
        justifyContent: "end",
    },
    '.role-header': {
        display: "flex",
        justifyContent: "space-between"
    },
    '.roles-cards': {
        display: "flex",
        flexDirection: "column",
        rowGap: 15
    },
    '.field-and-add-item': {
        display: "flex",
        columnGap: 15,
    },
    '.add-button': {
        marginTop: 4
    },
    '.data-cards': {
        display: "flex",
        columnGap: 15,
        rowGap: 15,
        flexWrap: "wrap",
        marginTop: 20
    },
    '.data-card': {
        display: "flex",
        flexDirection: "column",
        rowGap: 10,
        borderRadius: 8,
        padding: 15,
        background: "white",
        height: 220,
        width: 240
    },
    '.user-fileds': {
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        rowGap: 25,
        overflow: "auto"
    },
    '.user-card': {
        overflow: "auto",
        backgroundColor: white,
        flexGrow: 1,
        padding: 20
    },
    '.section': {
        display: "flex",
        flexDirection: "column",
        rowGap: 20
    },
    '.section-fields': {
        display: "flex",
        columnGap: 15
    },
    '.submit-actions': {
        display: "flex",
        justifyContent: "flex-end",
        columnGap: 10,
        marginBottom: 5,
        height: 30
    },
    '.role-card': {
        backgroundColor: white,
        width: 200,
        height: 220,
        padding: 20,
        borderRadius: 8
    },
    '.section-title': {
        display: "flex",
        justifyContent: "space-between",
    },
    '.user-roles': {
        backgroundColor: thirdly4,
        borderRadius: 20,
        padding: 15,
        display: "flex",
        flexDirection: "column",
        rowGap: 20
    },
    '.roles': {
        backgroundColor: bg,
        borderRadius: 10,
        padding: 15,
        display: "flex",
        flexDirection: "column",
        rowGap: 20
    },
    '.role-name': {
        width: "220px"
    },
    '.affiliation-name': {
        width: "220px"
    },
    '.select-role': {
        display: "flex",
        flexDirection: "column",
        rowGap: 5,
        padding: "10px 0px"
    },
    '.field-with-add-btn': {
        display: "flex",
        columnGap: 10,
        // alignItems: "center"
    },
    '.select-role-title': {
        fontWeight: 600
    },
    '.value-item': {
        background: "#D4DDEA",
        borderRadius: 21.5,
        padding: "0px 10px",
        height: 30,
        alignItems: "center",
        display: "flex",
        columnGap: 5,
        '.MuiSvgIcon-root': {
            fill: "#9DA4AD",
            cursor: "pointer",
            ':hover': {
                opacity: "0.7"
            }
        }
    },
    '.test-taker-list': {
        display: "flex",
        flexWrap: "wrap",
        columnGap: 10,
        rowGap: 10
    }
}));

export const UsersStyles = muiStyled(Box)(({ theme }) => ({
    height: " 100%",
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    '.bread-crumbs-title': {
        justifyContent: "end",
        width: "100%"
    }
}));

export const StatusCellStyles = muiStyled(Box)(({ theme }) => ({
    display: "flex",
    '.MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall .MuiAutocomplete-input': {
        textAlign: "center"
    }
}));

export const SchoolSummaryStyles = muiStyled(Box)(({ theme }) => ({
    backgroundColor: "white",
    borderRadius: 8,
    padding: 20,
    height: "100%",
    boxSizing: "border-box",
    width: 400,
    '.MuiPaper-root.MuiAccordion-root': {
        background: thirdly4,
        boxShadow: "none"
    },
    '.classes-list': {
        display: "flex",
        flexWrap: "wrap",
        columnGap: 10,
        rowGap: 10,
        '.MuiButtonBase-root.MuiButton-root': {
            minWidth: 30,
            padding: "3px 8px"
        }
    },
    '.summary-title': {
        fontWeight: "bold"
    },
    '.section-title': {
        color: "#26445A80",
        fontWeight: "bold"
    }
}));